import React from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';

import DataService from 'lib/DataService';

import Tooltip from 'components/Tooltip';
import Icon from 'components/Icon';
import { BigBlueButton } from 'lib/styles';

import {
	Container,
	Heading,
	Recipients,
	Column,
	Label,
	Controls,
	Input,
	New,
	AddIcon,
	Textarea,
	Actions,
	InlineAction,
	Link,
} from './styles';

const Api = new DataService();

class CollectionForm extends React.Component {
	constructor(props) {
		super(props);

		const { collection } = this.props;

		const messageTemplate = this.createMessageTemplate();
		const signatureTemplate = this.createSignatureTemplate();

		const name = collection && 'name' in collection.data ? collection.data.name : '';
		const recipients = collection && 'recipients' in collection.data ? collection.data.recipients : [{
			id: Api.generateUuid(),
			name: '',
			email: '',
		}];
		const message = collection && 'message' in collection && collection.message !== '' ? collection.message : messageTemplate;
		const signature = collection && 'signature' in collection && collection.signature !== '' ? collection.signature : signatureTemplate;
		const cc = collection && 'cc' in collection.data ? collection.data.cc : true;

		this.state = {
			loading: true,
			sending: false,
			sendSuccessful: false,
			error: [],
			name,
			recipients,
			message,
			signature,
			cc,
		}
	}

	componentWillReceiveProps(nextProps) {
		const { collection } = nextProps;

		const messageTemplate = this.createMessageTemplate();
		const signatureTemplate = this.createSignatureTemplate();

		const name = collection && 'name' in collection.data ? collection.data.name : '';
		const recipients = collection && 'recipients' in collection.data ? collection.data.recipients : [{
			id: Api.generateUuid(),
			name: '',
			email: '',
		}];
		const message = collection && 'message' in collection && collection.message !== '' ? collection.message : messageTemplate;
		const signature = collection && 'signature' in collection && collection.signature !== '' ? collection.signature : signatureTemplate;
		const cc = collection && 'cc' in collection.data ? collection.data.cc : true;

		this.setState({
			loading: true,
			sending: false,
			sendSuccessful: false,
			error: [],
			name,
			recipients,
			message,
			signature,
			cc,
		})
	}

	createMessageTemplate = () => {
	  const { lng } = this.props;

	  const messageTemplates = {
	    fi: `Hei,

Tässä lupaamani esitteet.`,
	    en: `Hi,

Here are the brochures I promised.`,
	  };

	  return messageTemplates[lng];
	}

	createSignatureTemplate = () => {
	  const { lng, user } = this.props;

	  const signatureTemplates = {
	    fi: `Ystävällisin terveisin,
${user.firstName} ${user.lastName}
${user.title}
Toimistokiinteistöt
Sponda Oy

${user.phone !== '' ? `mob. ${user.phone}\n` : ''}${user.email}
www.sponda.fi
Korkeavuorenkatu 45 | PL 940 | 00101 Helsinki`,
	    en: `Best regards,
${user.firstName} ${user.lastName}
${user.title}
Office Real Estate
Sponda Oyj

${user.phone !== '' ? `mob. ${user.phone}\n` : ''}${user.email}
www.sponda.fi
Yrjönkatu 29C | PL 940 | 00101 Helsinki`,
	  };

	  return signatureTemplates[lng];
	}

	saveCollection = () => {
	  if (!this.state.sending) {
	    const { id } = this.props.collection;
	    const { cc, name } = this.state;
	    const recipients = JSON.parse(JSON.stringify(this.state.recipients))
	      .filter(v => v.email !== '');
	    const message = this.state.message.trim();
	    const signature = this.state.signature.trim();

	    this.setState({
	      loading: true,
	      sending: true,
	      error: [],
	      name,
	      recipients,
	      message
	    });

	    Api.saveCollection({
	      id,
	      name,
	      recipients,
	      message,
	      signature,
	      cc
	    }).then(res => {
	      if (res.result.error) {
	        const error = res.result.error.error.message;

	        this.setState({
	          loading: false,
	          sending: false,
	          error
	        });
	      } else {
	        if (res.result.saved) {
	          this.props.collectionHandler(res.result.saved);
	          this.setState({
	            loading: false,
	            sending: false,
	          });
	        }
	      }
	    });
	  }
	}

	addRecipientHandler = () => {
	  const recipients = JSON.parse(JSON.stringify(this.state.recipients));

	  recipients.push({
	    id: Api.generateUuid(),
	    name: '',
	    email: '',
	  });

	  this.setState({ recipients });
	}

	removeRecipientHandler = index => {
	  const recipients = JSON.parse(JSON.stringify(this.state.recipients));

	  recipients.splice(index, 1);

	  if (recipients.length === 0) {
	    recipients.push({
	      id: Api.generateUuid(),
	      name: '',
	      email: '',
	    });
	  }

	  this.setState({ recipients });
	}

	updateRecipientHandler = (e, index) => {
	  const recipients = JSON.parse(JSON.stringify(this.state.recipients));
	  const recipient = recipients[index];

	  recipient[e.target.name] = e.target.value;

	  this.setState({ recipients });
	}

	updateMessageHandler = e => {
	  this.setState({ message: e.target.value });
	}

	updateSignatureHandler = e => {
	  this.setState({ signature: e.target.value });
	}

	sendCollectionHandler = () => {
	  const { t } = this.props;
	  if (!this.state.sending) {
	    const { id } = this.props.collection;
	    const { cc, name } = this.state;
	    const recipients = JSON.parse(JSON.stringify(this.state.recipients))
	      .filter(v => v.email !== '');
	    const message = this.state.message.trim();
	    const signature = this.state.signature.trim();

	    this.setState({
	      loading: true,
	      sending: true,
	      error: [],
	      name,
	      recipients,
	      message
	    });

	    Api.updateAndSendCollection({
	      id,
	      name,
	      recipients,
	      message,
	      signature,
	      cc
	    }).then(res => {
	      if (res.result.error) {
	        const error = res.result.error.error.message;

	        this.setState({
	          sending: false,
	          error
	        });
	      }

	      if (res.result.sent !== true && 'error' in res.result.sent) {
	        const error = res.result.sent.error.map(e => e.id);

	        this.setState({
	          sending: false,
	          error
	        });
	      }

	      if (res.result.sent) {
		    const clonedCollection = Object.assign({}, this.props.collection, { data: { name, recipients, cc }, signature, message });
		    this.props.collectionHandler(clonedCollection);
		    this.setState({
	            sending: false,
			 });
	        if (window.confirm(t('collection/Send/Confirm'))) {
			  this.newCollectionHandler(true);
	        }
	      }
	    });
	  }
	}

	newCollectionHandler = noConfirm => {
	  const { t } = this.props;

	  if (noConfirm || window.confirm(t('collection/Start a new collection/Confirm'))) {
	    const messageTemplate = this.createMessageTemplate();
	    const signatureTemplate = this.createSignatureTemplate();

	    this.setState({
	      loading: true,
	      name: '',
	      recipients: [{
	        id: Api.generateUuid(),
	        name: '',
	        email: '',
	      }],
	      message: messageTemplate,
	      signature: signatureTemplate,
	      cc: true,
	    });

	    Api.createCollection([])
	      .then(res => {
	        this.props.collectionHandler(res.result.collection);
	      });
	  }
	}

	toggleCcHandler = () => this.setState({ cc: !this.state.cc })

	render() {
	  const { t, lng, collection: { id } } = this.props;
	  const validForm = this.state.message.trim() !== '' &&
			this.state.recipients.length > 0 &&
			//this.state.recipients[0].name.trim() !== '' &&
			this.state.recipients[0].email.trim() !== '' &&
			this.props.brochureCount > 0;
	  const href = `${this.props.baseUrl}/${lng}/c/${id}/`;

	  return (
	    <Container>
	      <Heading>
	        {t('collection/Collection')}
	        <button onClick={() => this.saveCollection()}>{t('collection/Save')}</button>
	      </Heading>

	      <Column>
	        <Label>{t('collection/Collection name')}</Label>
	      </Column>
	      <Input
	        type="text"
	        name="name"
	        onChange={e => this.setState({ name: e.target.value })}
	        value={this.state.name}
	        style={{ marginBottom: '24px' }}
	      />

	      <Recipients>
	        {
	          false &&
						<Column><Label>{t('collection/Name')}</Label></Column>
	        }
	        <Column><Label>{t('collection/Email')}</Label></Column>
	        <div />

	        { this.state.recipients.map((recipient, index) => {
	          const canRemove = index > 0 || recipient.name !== '' || recipient.email !== '';

	          return (
	            <React.Fragment key={recipient.id}>
	              {
	                false &&
									<Column>
									  <Input
									    type="text"
									    name="name"
									    onChange={e => this.updateRecipientHandler(e, index)}
									    defaultValue={ recipient.name }
									    placeholder={t('collection/Name/Placeholder')}
									  />
									</Column>
	              }

	              <Input
	                type="email"
	                name="email"
	                onChange={e => this.updateRecipientHandler(e, index)}
	                defaultValue={ recipient.email }
	                error={this.state.error.includes(recipient.id)}
	                placeholder={t('collection/Email/Placeholder')}
	                style={{ width: 'calc(80% + 32px)', marginBottom: '8px' }}
	              />

	              { canRemove &&
									<Controls>
									  <Tooltip
									    onClickHandler={() => this.removeRecipientHandler(index)}
									    icon="trash"
									    tooltip={t('collection/Recipient/Remove')}
									  />
									</Controls>
	              }
	            </React.Fragment>
	          )
	        })}
	      </Recipients>

	      <div />

	      <New onClick={this.addRecipientHandler}>
	        <AddIcon icon="add-solid" className="icon" /> {t('collection/Recipient/Add new recipient')}
	      </New>

	      <div />

	      <Label>{t('collection/Message')}</Label>
	      <Textarea
	        value={this.state.message}
	        placeholder={t('collection/Message/Placeholder')}
	        onChange={e => this.updateMessageHandler(e)}
	      />

	      <Label>{t('collection/Signature')}</Label>
	      <Textarea
	        value={this.state.signature}
	        placeholder={t('collection/Signature/Placeholder')}
	        onChange={e => this.updateSignatureHandler(e)}
	      />

	      <Label htmlFor="cc" style={{ display: 'block', cursor: 'pointer', marginBottom: '24px' }}>
	        <input id="cc" type="checkbox" checked={this.state.cc} onChange={this.toggleCcHandler} /> {t('collection/Cc')}
	      </Label>

	      <Actions>
	        <div>
	          <InlineAction onClick={() => this.newCollectionHandler(false)}>{t('collection/Start a new collection')}</InlineAction>
	        </div>

	        <BigBlueButton
	          onClick={this.sendCollectionHandler}
	          disabled={this.state.sending || !validForm}
	        >
	          { this.state.sending ? t('collection/Sending') : t('collection/Send') }
	        </BigBlueButton>
	      </Actions>

	      <Link href={href} target="_blank">
	        <Icon icon="view-show" className="icon" /> { href }
	      </Link>

	    </Container>
	  );
	}
}

CollectionForm.propTypes = {
	t: PropTypes.func,
	lng: PropTypes.string,
	collection: PropTypes.any,
	brochureCount: PropTypes.number,
	baseUrl: PropTypes.string,
	user: PropTypes.object,
	collectionHandler: PropTypes.func,
}

export default translate('translations')(CollectionForm)
